import React, { FunctionComponent, useState, useEffect } from "react";
import styles from "./DeleteModal.module.css";
import { IoIosClose } from "react-icons/io";
import { connect, useDispatch } from "react-redux";
import { themeColors } from "../../theme";
import { motion, AnimatePresence } from "framer-motion";
import Backdrop from "../../Backdrop/Backdrop";

type props = {
  close: () => void;
  onSubmit: () => void;
};

const dropIn = {
  hidden: {
    y: "-100vh",
    opacity: 1,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
};

const TemplateStatusModal: FunctionComponent<props> = ({
  close,
  onSubmit
}) => {
  // const [value, setValue] = useState("");

  // const onSubmit = () => {
  //   try {
  //     if (value.trim() === "" || value === undefined || value === null) {
  //       dispatcher(
  //         showSnackbarAction("Please enter value", "error")
  //       );
  //       return
  //     }
  //     const obj = [{
  //       [subType]: value?.trim(),
  //       modified_by: user.uid
  //     }]
  //     if (setdata) {
  //       setdata(value?.trim());
  //     }
  //     console.log("value", value)
  //     createResourceMongo(
  //       user.organization_id,
  //       type,
  //       obj,
  //       dispatcher,
  //       setLoad,
  //       close,
  //       authToken,
  //       reload
  //     )
  //   } catch (error) {

  //   }
  // };

  return (
    <Backdrop>
      <motion.div
        key="modal"
        className="card p-4 shadow rounded"
        style={{
          position: "absolute",
          backgroundColor: themeColors.backgroundColor, color: themeColors.textPrimary
        }}
        variants={dropIn}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <div className={styles.headingContainer}>
          <h6>Are you sure you want to delete the template?</h6>
        </div>
        <div className={styles.button}>
          <button className={styles.change} onClick={onSubmit}>
            Delete
          </button>
          <button className={styles.cancel} onClick={close}>
            Cancel
          </button>
        </div>
      </motion.div>
    </Backdrop>
  );
};

const mapStateToProps = (state: any) => {
  return {
    // user: state.user.data,
    // contacts: state.contacts,
    // theme: state.theme.isLightMode,
    // authToken: state.user.authToken,
    // organizationData: state.organization.organizationData,
    // constants: state.constants.data,
  };
};

export default connect(mapStateToProps)(TemplateStatusModal);